exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__panel___UlHjz {\n  background: #fafafa;\n  overflow-y: auto;\n  margin: 0 5px 0 0;\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"panel": "style__panel___UlHjz"
};